import * as hooks from './hooks';
import TtamCreativeToolVideoEditor from './tool-video-editor.vue';

export default {
  ...hooks,
  TtamCreativeToolVideoEditor,
};
